module.exports = __webpack_public_path__ + "img/grondplan.5055ac66.jpg";